package dev.lingvo.shared.screenshots.scene

import dev.lingvo.shared.screenshots.ScreenshotEngine
import dev.lingvo.shared.screenshots.doc.FrameKind
import dev.lingvo.shared.screenshots.geom.Rect

// The merged frame implementation is the source of truth for body and structural outer proportions.
internal fun frameOuterAspect(kind: FrameKind, screenAspect: Double): Double {
    val outer = ScreenshotEngine.frames.layout(kind, Rect(0.0, 0.0, 1000.0, 1000.0), screenAspect).outer
    return outer.h / outer.w
}
